import api from "@/services/api.service";

export default {
  name: "list",
  components: {},
  props: {
    caption: {
      type: String,
      default: "Marketing Event list"
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      icon: 'fa fa-sort',
      selcol: '',
      items: [],
      permissions: [],
      fields: [
      { key: "#" },
      { key: "title", sortable: false },
      { key: "campaign", sortable: false },
      // { key: "admin", sortable: false },
      { key: "vendor", sortable: false },
      { key: "actions" }
      ],
      sech: {},
      currentSortDir:'desc',            
      currentPage: 1,
      perPage: 10,
      totalRows: null,
      totalMarketing: null,
      isBusy: true,
      delete_ids: [],
      allSelected: false,
      file_path : process.env.VUE_APP_EVENT_REQUEST_FILE_URL,
      colName : '', 
      permission_list: false,           
      permission_add: false,           
      permission_delete: false,
      permission_edit: false,
      permission_assignVendor: false,           
      permission_editVendor: false,           
      permission_requestContacts: false,           
      permission_downloadRequestContacts: false,    
      permission_uploadResponse: false,       
      permission_responseContacts: false,       
      permission_listAgent: false,       
      superAdmin: false
    };
  },
  computed: {},
  mounted() {},
  created() {
    this.getMarketing();
    this.getUserPermissions();
  },
  watch: {
    currentPage: {
      handler: function(page) {
        // this.getMarketing(page);
        this.toSort(this.colName,page);                
      }
    }
  },
  methods: {
    makeToast(message = "", title = "Alert", variant = "warning") 
    {
      this.toastCount++;
      this.$root.$bvToast.toast(message, {
        title: title,
        variant: variant,
        autoHideDelay: 3000
      });
    },
    selectAll: function(e) 
    {
      this.delete_ids = [];            
      if(e.target.checked){
        for (var item in this.items) {
          this.delete_ids.push(this.items[item].id.toString());
        }                
      }            
    },
    selectOne()
    {
      this.allSelected = false;            
    },
    async getUserPermissions(){
      let response = await api.post("users/user-permissions");
      const permissions = [];
      if (response.status == "success") {
        response.data[0].permission.forEach( function(element) {                
            permissions.push(element.action)
        }.bind(this));
        this.permission_list = permissions.includes("list_event");
        this.permission_add = permissions.includes("add_event");
        if(this.permission_list == true || this.permission_add == true){          
          this.permission_edit = permissions.includes("edit_event");
          this.permission_delete = permissions.includes("delete_event");
          this.permission_assignVendor = permissions.includes("add_vendor_event");
          this.permission_editVendor = permissions.includes("edit_vendor_event");
          this.permission_requestContacts = permissions.includes("request_contact_list_vendor_event");
          this.permission_downloadRequestContacts = permissions.includes("download_request_contact_event");
          this.permission_uploadResponse = permissions.includes("upload_response_event");
          this.permission_responseContacts = permissions.includes("uploaded_response_list_event");
          this.permission_listAgent = permissions.includes("list_agent_event");
        }else if(response.data[0].role == 'super_admin'){
          this.superAdmin = true;
        }else{
          this.makeToast("Permission denied","Alert","warning",6000);
          this.$router.push({name: 'Admin Dashboard'});
        }
      }
    },
    async toSort (items,page = 1)
        {  
            if (items == 'campaign') { items = 'campaign_id'; }  
            if (items == 'admin') { items = 'admin_id'; }  
            if (items == 'vendor') { items = 'vendor_id'; }  
                
            if (items != "actions" && items != "#") {                
                // this.isBusy = true;
                if(page == 1)
                if(items == this.colName)
                this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc'; 

                this.colName = items; 
                this.isBusy = true;                   
                let response = await api.post("marketing-event/list",{ page:page,columnname:items,sortType:this.currentSortDir,paginateVal:this.perPage});
                if (response.status == "success") {
                    if (response.data != "") {
                        if(this.currentSortDir == 'asc'){
                            this.icon1 = 'fa fa-sort-up';                             
                            this.selcol = items;        
                        } else{ 
                            this.icon1 = 'fa fa-sort-down';                             
                            this.selcol = items;
                        }                        
                        this.items = response.data.data;
                        this.totalMarketing = response.data.total;
                        this.currentPage = response.data.current_page;
                        this.perPage = response.data.per_page;
                    } else {
                        this.items = [];
                    }
                }
               this.isBusy = false;   
            }            
        },
    async getMarketing(page) 
    {
      this.sech.page = page;
      let response = await api.post("marketing-event/list", this.sech);
      if (!response)
        this.makeToast("Something went to wrong please try again","Alert","danger",6000);
      if (response.status == "success") {
        if (response.data != "") {
          this.items = response.data.data;
          this.totalMarketing = response.data.total;
          this.currentPage = response.data.current_page;
          this.perPage = response.data.per_page;

          this.pageOptions.forEach(element => {
            if(element.value > this.totalMarketing){
                var indexOf = this.pageOptions.indexOf(element);
                if( indexOf != 0 )
                this.pageOptions.splice(indexOf)
            }
          });
          if(this.totalMarketing <= 500)
          this.pageOptions.push({text:'All',value:this.totalMarketing});
        } else {
          this.items = [];
        }
      }      
      this.isBusy = false;
    },
    getRowCount(items) 
    {
      return items.length;
    },
    updateMarketing(id) 
    {
      this.$router.push({ name: "Edit Event", params:{id:id}});
    },
    multipleDelete()
    {
      this.$bvModal
      .msgBoxConfirm("Are you sure want to delete this Marketing Event?")
      .then(value => {
        if (value) {
          this.deleteMarketing(this.delete_ids, 0);
        } else {
          return;
        }
      })
      .catch(function() {
        return;
      });
    },singleDelete(id, index) {
      this.$bvModal
      .msgBoxConfirm("Are you sure want to delete this Marketing Event?")
      .then(value => {
        if (value) {
          this.deleteMarketing(id, index);
        } else {
          return;
        }
      })
      .catch(function() {
        return;
      });
    }, 
    async deleteMarketing(id, index) 
    {
      let response = await api.post("admin/marketing-event/delete",{ id: id });

      if (!response)
        this.makeToast("Something went to wrong please try again","Alert","danger",6000);

      if (response.status == "success") {

        if(index == 0)
          this.getMarketing();
        else
          this.items.splice(index, 1);

        this.makeToast(response.message || `Marketing Event delete successful.`,"Alert","success");
      } 
      else 
        this.makeToast(`Marketing Event not deleted.`, "Alert", "danger");
    },
    assignVendor(id)
    {      
      this.$router.push({ name: "Assign Vendor" , params:{'id':id}});
    },
    uploadResponse(id)
    {
      this.$router.push({ name: "Upload Response" , params:{'id':id}});
    },
    uploadResponselist(id)
    {
      this.$router.push({ name: "Upload Response List" , params:{'id':id}});
    },
    showResult() 
    {
      this.$router.push({ name: "Show Result" });
    },
    editVendor(id)
    { 
      this.$router.push({ name: "Edit Vendor" , params:{'id':id}});
    },
    RequestContactList(id,request_id)
    {      
      this.$router.push({ name: "Request Contacts" , params:{id:id,request_id:request_id}});
    },
    async downloadMarketingRequestContacts(event_id,request_id)
    {

      let response = await api.post("marketing-event/download-marketing-request-contacts",
        { marketing_event_id: event_id ,request_id : request_id });

      if (!response)
        this.makeToast("Something went to wrong please try again","Alert","danger",6000);

      if (response.status == "success") {        
        window.open(response.data, "_blank");
        this.makeToast(`Marketing Event download successful.`,"Alert","success");
      } 
      else 
        for (var error in response.errors)
          this.makeToast(response.errors[error], 'Alert', 'danger', 6000)

      },
      ResponseContactList(id)
      {
        this.$router.push({ name: "Response Contacts" , params:{'id':id}});
      },
      agentList(id)
      {
        this.$router.push({ name: "Agent List" , params:{'id':id}});
      }      
    }
  };
